import React, { useState } from 'react';

const CopyButton = ({ text, label = 'Copy' }) => {
  const [done, setDone] = useState(false);
  const onCopy = async () => {
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(text);
      } else {
        const ta = document.createElement('textarea');
        ta.value = text;
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
      }
      setDone(true);
      setTimeout(() => setDone(false), 1600);
    } catch {
      // fail silently — user can long-press
    }
  };
  return (
    <button className={`copy-btn ${done ? 'copied' : ''}`} onClick={onCopy}>
      {done ? '✓ Copied' : label}
    </button>
  );
};

export default CopyButton;
